import React from "react";
import "./OurPromise.css";
import { FaShippingFast, FaUndoAlt, FaCertificate, FaTags } from "react-icons/fa";

const promises = [
  {
    icon: <FaShippingFast />,
    title: "Free Shipping",
    desc: "We offer Free Shipping all over India. Your sparkle, delivered safely and fast."
  },
  {
    icon: <FaUndoAlt />,
    title: "Returns Accepted",
    desc: "Enjoy worry-free shopping. Easy returns on select styles and designs."
  },
  {
    icon: <FaTags />,
    title: "Competitive Pricing",
    desc: "Luxury that doesn’t break the bank. Fair pricing for timeless designs."
  },
  {
    icon: <FaCertificate />,
    title: "Certified Jewelry",
    desc: "Every piece is BIS hallmarked or IGI certified. Authenticity guaranteed."
  }
];

const OurPromise = () => {
  return (
    <section className="our-promise-sectionn">
      <h2 className="section-titlee">Our Promise</h2>
      <div className="promise-gridd">
        {promises.map((item, index) => (
          <div className="promise-cardd" key={index}>
            <div className="iconn">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurPromise;
